import { PartialType } from '../../../../utils';
import { CreateDaily7InsuranceFeeDto } from './create-daily-7-insurance-fee.dto';
export class UpdateDaily7InsuranceFeeDto extends PartialType(CreateDaily7InsuranceFeeDto) {
}
